import { colors } from '../../../ui-components';

class StaticComponent {
  constructor(contentfulNode) {
    this.component = contentfulNode?.component;
    this.type = 'CONTENT_COMPONENT';
    this.defaultColor = colors.sandBeige;
  }
}

export { StaticComponent };
